import { c as _c } from "react/compiler-runtime";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { formatDate } from "date-fns";
import { Control, FieldPath, FieldValues, useWatch } from "react-hook-form";
type Props<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>> = {
  name: TFieldName;
  label?: string;
  control: Control<TFieldValues, TFieldName>;
};
export function TimeInput(t0) {
  const $ = _c(14);
  let control;
  let name;
  let props;
  if ($[0] !== t0) {
    ({
      control,
      name,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = control;
    $[2] = name;
    $[3] = props;
  } else {
    control = $[1];
    name = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== control || $[5] !== name) {
    t1 = {
      control,
      name
    };
    $[4] = control;
    $[5] = name;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const date = useWatch(t1);
  let t2;
  if ($[7] !== date || $[8] !== props.label) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem className="relative flex flex-col"><FormLabel className="leading-5">{props.label}</FormLabel><FormControl><Input {...field} type="time" className="h-auto rounded-none bg-white p-4 font-roboto focus:border-matchbus md:text-lg" onChange={e => {
            if (!e.target.value || !e.target.value.includes(":")) {
              console.warn("Invalid time value of '" + e.target.value + "'! Ignoring.");
              return;
            }
            const [hours, minutes] = e.target.value.split(":");
            date.setHours(Number(hours), Number(minutes), 0, 0);
            field.onChange(new Date(date));
          }} value={date ? formatDate(date, "HH:mm") : ""} /></FormControl><FormMessage /></FormItem>;
    };
    $[7] = date;
    $[8] = props.label;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== control || $[11] !== name || $[12] !== t2) {
    t3 = <FormField control={control} name={name} render={t2} />;
    $[10] = control;
    $[11] = name;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}